import { render, staticRenderFns } from "./GestioneProfilo.vue?vue&type=template&id=7a759746&"
import script from "./GestioneProfilo.vue?vue&type=script&lang=js&"
export * from "./GestioneProfilo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports